import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WINDOW } from '@core/http/window.providers';
import { LocalStorage } from '@core/localstorage';

@Component({
    selector: 'app-tournament-card',
    templateUrl: './tournament-card.component.html',
    styleUrls: ['./tournament-card.component.scss'],
})
export class TournamentCardComponent implements OnInit {
    @Input() isEvent: boolean = false;
    @Input('tournament') tournament: any;

    constructor(private router: Router, private localStorage: LocalStorage, @Inject(WINDOW) private window) {}

    ngOnInit(): void {}

    onTournamentClick(tournament) {
        if (tournament.redirect_site_personal) {
            const pathArray = tournament.redirect_site_personal.split('/');
            const host = pathArray.splice(0, 1);
            const currentUserToken = this.localStorage.getToken();
            const finalURL = `https://${host}/redirect-token?token=${currentUserToken}&path=${pathArray.join('/')}`;
            this.window.open(finalURL, '_blank');
            return;
        }
        if (tournament.id_evento) {
            return this.router.navigate(['/events/', tournament.id_evento]);
        }
        this.router.navigate(['/' + tournament.route + '/tournament/', tournament.id_torneio]);
    }
}
